export default {"src":"/_next/static/media/icon-Viet-Nam.4582239d.svg","height":25,"width":36,"blurWidth":0,"blurHeight":0};